__turbopack_context__.v({
  "bar": "ReadingProgress-module__TJKf_G__bar",
  "percentage": "ReadingProgress-module__TJKf_G__percentage",
  "root": "ReadingProgress-module__TJKf_G__root",
});
